<template>
  <div id="app" class="flex-row flex-main-center">

    <div style="width:13.66rem;height:100%">
      <transition :name="transitionName">
        <keep-alive >
          <router-view />
        </keep-alive>
      </transition>
    </div>

    <com-popup-loan ref="popupLoan">
    </com-popup-loan>

     <com-popup-help ref="popupHelp">
    </com-popup-help>

  </div>
</template>

<script>
import comPopupLoan from '@/components/comPopupLoan'
import comPopupHelp from '@/components/comPopupHelp'
import Vue from  'vue';
export default {
  name: 'app',
  data(){
    return  {
      // transitionName: "normal", //定义当前的页面切换过渡的方式
    }
  },
  mounted(){
    Vue.prototype.$urlDownloadApp="https://play.google.com/store/apps/details?id=com.yinshan.program.banda";
    Vue.prototype.$popupHelp = this.$refs.popupHelp;

    Vue.prototype.$popupLoan = this.$refs.popupLoan;
  },
  components: {
    comPopupHelp,comPopupLoan
  }
}
</script>


<style lang="scss">
/*主css文件引入口*/
@import "css/theme.scss";
</style>

<style>
#app {
  width:100%;height:100%;
  /*min-width:13.66rem;*/

}
</style>
